import React from 'react';
import { Typography } from '@mui/material';

const JwtBearerFields = ({ t }) => {
    return (
        <Typography variant="body2" color="textSecondary">
            {t('JWT_BEARER')}
        </Typography>
    );
};

export default JwtBearerFields;

